import React, { useEffect, useMemo, useState } from 'react'
import { Button, Col, Form, Modal, OverlayTrigger, Row, Spinner, Tooltip } from 'react-bootstrap'
import KapalService from '../../../../services/kapal/KapalService'
import JenisDokumenKapal from '../../../../utilities/kapal/JenisDokumenKapal'
import { AsyncPaginate } from 'react-select-async-paginate'
import SweetAlert from 'react-bootstrap-sweetalert'
import { FaMagnifyingGlass } from 'react-icons/fa6'

const ModalEvp = ({ showEvp, handleCloseEvp, dataPpmKapal, dataDisposisi, reloadList, isEdit }) => {

    let kapalService = useMemo(() => new KapalService(), [])

    const [listDokWajib, setListDokWajib] = useState([])
    const [hasilEvpDok, setHasilEvpDok] = useState([])

    useEffect(() => {
        if (!dataPpmKapal) return
        const fetchAllData = async () => {
            try {
                let isOver5Gt = dataPpmKapal.ukuranKapal <= 5 ? 'T' : 'Y'
                let isPembeku = dataPpmKapal.fasilitasPembeku === '1' ? 'Y' : 'T'

                const resDokWajib = await kapalService.listDokumenWajib(isOver5Gt, isPembeku)
                setListDokWajib(resDokWajib.data.data)

                const resHasilEvp = await kapalService.listHasilEvPermohonan(dataPpmKapal.nomorAjuKapal)
                if (resHasilEvp) {
                    const hasilEvp = resHasilEvp.data.data[0]
                    setValueCatatan(hasilEvp.catatanPeriksa)

                    const resKesimpulan = await kapalService.getKesimpulanById(hasilEvp.idKesimpulan)
                    setValueKesimpulanOpt(resKesimpulan.data)

                    const resHasilEvpDok = await kapalService.listHasilEvPermohonanDok(dataPpmKapal.nomorAjuKapal, hasilEvp.idEvp)
                    // console.log(resHasilEvpDok.data.data)
                    setHasilEvpDok(resHasilEvpDok.data.data)

                }
            } catch (error) {

            }
        }
        fetchAllData()
    }, [kapalService, dataPpmKapal, dataDisposisi])

    const [valueCatatan, setValueCatatan] = useState(null)

    const onChangeCatatan = e => {
        console.log(hasilEvpDok)
        setValueCatatan(e.target.value)
    }

    const handleChangeRadioLengkap = (id, value) => {
        setHasilEvpDok((prev) => {
            // cari dulu data yang sudah ada
            const existing = prev.find((item) => item.idJenisDok === id);
            if (existing) {
                // update field lengkap
                return prev.map((item) =>
                    item.idJenisDok === id ? { ...item, isLengkap: value } : item
                );
            } else {
                // kalau belum ada, push baru
                return [...prev, { idJenisDok: id, isLengkap: value, isSesuai: null }];
            }
        });
    }

    const handleChangeRadioSesuai = (id, value) => {
        // console.log(e)
        setHasilEvpDok((prev) => {
            const existing = prev.find((item) => item.idJenisDok === id);
            if (existing) {
                return prev.map((item) =>
                    item.idJenisDok === id ? { ...item, isSesuai: value } : item
                );
            } else {
                return [...prev, { idJenisDok: id, isLengkap: null, isSesuai: value }];
            }
        });
    }

    const [valueKesimpulanOpt, setValueKesimpulanOpt] = useState(null)
    const onChangeKesimpulan = e => {
        setValueKesimpulanOpt(e)
    }

    async function loadOptionKesimpulan(search, loadedOption, { page = 1 }) {
        const response = await kapalService.listKesimpulan(dataDisposisi.idDisposisi)
        return {
            options: response.data,
        }
    }

    const [showConfirmProses, setShowConfirmProses] = useState(false)
    const handleCloseConfirmProses = () => setShowConfirmProses(false)
    const handleClickConfirmProses = () => {
        setShowConfirmProses(true)
    }

    const [loadingProses, setLoadingProses] = useState(false)
    const [showProsesSuccess, setShowProsesSuccess] = useState(false)
    const [showProsesFailed, setShowProsesFailed] = useState(false)

    const handleCloseSuccess = () => {
        setShowProsesSuccess(false)
        reloadList(0, 10, dataPpmKapal.nomorAjuKapal)
    }

    const handleCloseFailed = () => {
        setShowProsesFailed(false)
        reloadList(0, 10, dataPpmKapal.nomorAjuKapal)
    }

    const handleClickProses = async () => {
        setLoadingProses(true)
        try {
            let jsonHasilEvp = {
                nomorAjuKapal: dataPpmKapal.nomorAjuKapal,
                nipPeriksa: localStorage.getItem('username'),
                nmPeriksa: localStorage.getItem('nama'),
                tglPeriksa: new Date(),
                catatanPeriksa: valueCatatan,
                idKesimpulan: valueKesimpulanOpt.idKesimpulan,
                createdBy: localStorage.getItem('userId'),
                createdDate: new Date()
            }
            const resSaveHasilEvp = await kapalService.saveHasilEvPermohonan(jsonHasilEvp)
            if (resSaveHasilEvp.data.kode === '200') {
                //ev permohonan dok
                const idEvp = resSaveHasilEvp.data.id

                hasilEvpDok.map(async (evpDok) => {
                    let newEvpDok = {
                        ...evpDok,
                        idEvp: idEvp,
                        nomorAjuKapal: dataPpmKapal.nomorAjuKapal,
                        createdBy: localStorage.getItem('userId'),
                        createdDate: new Date()
                    }
                    await kapalService.saveHasilEvPermohonanDok(newEvpDok)
                })

                let dataDispo = {
                    ...dataDisposisi,
                    noTugas: 'EVP-' + dataPpmKapal.nomorAjuKapal,
                    tglTugas: new Date()
                }
                await kapalService.savePenugasan(dataDispo)

                let idDisposisi
                let kdStatus

                if (localStorage.getItem('isMandatoryPrimer') === 'Y') {
                    if (valueKesimpulanOpt.idKesimpulan === 3) {
                        idDisposisi = 21
                        kdStatus = '052'
                    } else {
                        kdStatus = '110'
                    }
                } else {
                    idDisposisi = valueKesimpulanOpt.idDisposisiNext
                    kdStatus = valueKesimpulanOpt.kdStatusNext
                }

                if (valueKesimpulanOpt.idKesimpulan === 3) {
                    let jsonDisposisi = {
                        nomorAjuKapal: dataPpmKapal.nomorAjuKapal,
                        createdBy: localStorage.getItem('userId'),
                        idDisposisi: idDisposisi,
                        createdDate: new Date()
                    }
                    await kapalService.savePenugasan(jsonDisposisi)
                }
                let jsonStatus = {
                    nomorAjuKapal: dataPpmKapal.nomorAjuKapal,
                    waktuStatus: new Date(),
                    createdBy: localStorage.getItem("userId"),
                    kodeStatus: kdStatus,
                    createdAt: new Date()
                }
                await kapalService.saveKapalStatus(jsonStatus)

                let jsonKapal = {
                    ...dataPpmKapal,
                    kodeStatus: kdStatus,
                    updatedBy: localStorage.getItem('userId'),
                    updatedDate: new Date()
                }
                await kapalService.saveKapalHeader(jsonKapal)

                setShowConfirmProses(false)
                setShowProsesSuccess(true)
            } else {
                setShowConfirmProses(false)
                setShowProsesFailed(true)
            }
        } catch (error) {
            setShowConfirmProses(false)
            setShowProsesFailed(true)
        }
        setLoadingProses(false)
    }

    const handleClickClose = () => {
        // setHasilEvpDok([])
        // setValueCatatan('')
        // setValueKesimpulanOpt(null)
        handleCloseEvp()
    }

    const [showOpenPreview, setShowOpenPreview] = useState(false)
    const handleClosePreview = () => {
        setBase64String(null)
        setShowOpenPreview(false)
    }

    const [base64String, setBase64String] = useState(null)

    const handleClickPreviewDok = async (idJnsDok, nomorAju) => {
        try {
            const resDok = await kapalService.getKapalDokumenByAjuKodeDok(nomorAju, idJnsDok)
            if (resDok.data !== '') {
                setBase64String(resDok.data.dokPath)
                setShowOpenPreview(true)
            }
        } catch (error) {
            console.log(error)
        }
    }

    return (
        <>
            <Modal
                show={showEvp}
                onHide={handleCloseEvp}
                size='xl'
                centered
                scrollable
            >
                <Modal.Header>
                    <Modal.Title><h5>Evaluasi Permohonan</h5></Modal.Title>
                    {(localStorage.getItem('isMandatoryPrimer') === 'T') && <span className='text-danger'>Evaluasi Permohonan oleh Pusat</span>}
                </Modal.Header>
                <Modal.Body>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Nomor Aju Kapal</Form.Label>
                                    <Col sm="6">
                                        <Form.Control type="text" placeholder="NIB" className="form-control-sm" value={dataPpmKapal.nomorAjuKapal} disabled />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-6'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">Nama Kapal</Form.Label>
                                    <Col sm="8">
                                        <Form.Control type="text" placeholder="Nama Kapal" className="form-control-sm" value={dataPpmKapal.namaKapal} disabled />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                        <div className='col-6'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">Ukuran Kapal</Form.Label>
                                    <Col sm="2">
                                        <Form.Control type="text" placeholder="Nama Kapal" className="form-control-sm" value={dataPpmKapal.ukuranKapal} disabled />
                                    </Col>
                                    <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">GT</Form.Label>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Fasilitas Pembeku</Form.Label>
                                    <Col sm="6">
                                        <Form.Control type='text' placeholder="alamat" className="form-control-sm" value={dataPpmKapal.fasilitasPembeku === '1' ? 'Dengan alat pembeku (freezer fishing vessel)' : 'Tanpa alat pembeku (non freezer fishing vessel)'} disabled />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Status Permohonan</Form.Label>
                                    <Col sm="4">
                                        <Form.Control type="text" placeholder="Nama Kapal" className="form-control-sm" value={dataPpmKapal.statusPermohonan === '1' ? 'Baru' : 'Perpanjangan'} disabled />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12'>
                            <h6>Checklist Kelengkapan & Kesesuaian Dokumen Permohonan</h6>
                        </div>
                    </div>
                    {
                        listDokWajib &&
                        listDokWajib.map((dokwajib, idx) => {
                            const current = hasilEvpDok.find((h) => h.idJenisDok === dokwajib.idJenisDok)

                            return (
                                <div className='row' key={dokwajib.idJenisDok || idx}>
                                    <div className='col-12'>
                                        <Form>
                                            <Form.Group as={Row} className="form-group">
                                                <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib"><JenisDokumenKapal id={dokwajib.idJenisDok} /></Form.Label>
                                                <Col sm="4">
                                                    <div className="form-check form-check-inline">
                                                        <input className="form-check-input" type="radio"
                                                            name={'inlineRadioLengkap' + dokwajib.idJenisDok}
                                                            id={'inlineRadioLengkap' + dokwajib.idJenisDok}
                                                            value="1"
                                                            checked={current?.isLengkap === "1"}
                                                            onChange={(e) => handleChangeRadioLengkap(dokwajib.idJenisDok, e.target.value)} />
                                                        <label className="form-check-label" for={'inlineRadioLengkap' + dokwajib.idJenisDok}>Lengkap</label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input className="form-check-input" type="radio"
                                                            name={'inlineRadioLengkap' + dokwajib.idJenisDok}
                                                            id={'inlineRadioLengkap' + dokwajib.idJenisDok}
                                                            value="0"
                                                            checked={current?.isLengkap === "0"}
                                                            onChange={(e) => handleChangeRadioLengkap(dokwajib.idJenisDok, e.target.value)} />
                                                        <label className="form-check-label" for={'inlineRadioLengkap' + dokwajib.idJenisDok}>Tidak Lengkap</label>
                                                    </div>
                                                </Col>
                                                <Col sm="3">
                                                    <div className="form-check form-check-inline">
                                                        <input className="form-check-input" type="radio"
                                                            name={'inlineRadioSesuai' + dokwajib.idJenisDok}
                                                            id={'inlineRadioSesuai' + dokwajib.idJenisDok}
                                                            value="1"
                                                            checked={current?.isSesuai === "1"}
                                                            onChange={(e) => handleChangeRadioSesuai(dokwajib.idJenisDok, e.target.value)} />
                                                        <label className="form-check-label" for={'inlineRadioSesuai' + dokwajib.idJenisDok}>Sesuai</label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input className="form-check-input" type="radio"
                                                            name={'inlineRadioSesuai' + dokwajib.idJenisDok}
                                                            id={'inlineRadioSesuai' + dokwajib.idJenisDok}
                                                            value="0"
                                                            checked={current?.isSesuai === "0"}
                                                            onChange={(e) => handleChangeRadioSesuai(dokwajib.idJenisDok, e.target.value)} />
                                                        <label className="form-check-label" for={'inlineRadioSesuai' + dokwajib.idJenisDok}>Tidak Sesuai</label>
                                                    </div>
                                                </Col>
                                                <Col sm="1">
                                                    <OverlayTrigger placement="bottom" overlay={
                                                        <Tooltip >Preview Dokumen</Tooltip>
                                                    }>
                                                        <Button size="sm" variant="outline-info" onClick={() => handleClickPreviewDok(dokwajib.idJenisDok, dataPpmKapal.nomorAjuKapal)}>
                                                            <FaMagnifyingGlass />
                                                        </Button>
                                                    </OverlayTrigger>{' '}
                                                </Col>
                                            </Form.Group>
                                        </Form>
                                    </div>
                                </div>
                            )
                        })
                    }
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Catatan</Form.Label>
                                    <Col sm="8">
                                        <Form.Control as="textarea" placeholder="Catatan" className="form-control-sm" value={valueCatatan} onChange={onChangeCatatan} />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Kesimpulan <span className='text-danger'>*</span></Form.Label>
                                    <Col sm="8">
                                        <AsyncPaginate
                                            loadOptions={loadOptionKesimpulan}
                                            value={valueKesimpulanOpt}
                                            getOptionValue={(option) => option.idKesimpulan}
                                            getOptionLabel={(option) => option.urKesimpulan}
                                            additional={{
                                                page: 0,
                                            }}
                                            onChange={onChangeKesimpulan}
                                            isDisabled={!isEdit}
                                        />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    {isEdit && (localStorage.getItem("role") === "6" || localStorage.getItem("isMandatoryPrimer") === 'Y') && <Button variant="primary" size="sm" onClick={() => handleClickConfirmProses()}>Proses</Button>}{' '}
                    <Button variant="danger" size="sm" onClick={() => handleClickClose()}>Batal</Button>
                </Modal.Footer>
            </Modal>
            <PreviewPdf showOpenPreview={showOpenPreview} handleClosePreview={handleClosePreview} base64string={base64String} />
            {
                showConfirmProses &&
                <SweetAlert
                    title="Proses Evaluasi Permohonan?"
                    warning
                    showCancel
                    confirmBtnText={
                        loadingProses ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Proses Simpan...
                            </>
                        ) : (
                            "Proses"
                        )
                    }
                    confirmBtnBsStyle="primary"
                    cancelBtnText="Batal"
                    cancelBtnBsStyle="secondary"
                    onConfirm={handleClickProses}
                    onCancel={handleCloseConfirmProses}
                    focusCancelBtn
                    btnSize="sm"
                    disabled={loadingProses}
                    reverseButtons
                >
                    {loadingProses && (
                        <div className="text-center">
                            <Spinner animation="border" variant="primary" />
                            <p className="mt-2">Proses Simpan data, harap tunggu...</p>
                        </div>
                    )}
                </SweetAlert>
            }
            {
                showProsesSuccess &&
                <SweetAlert
                    success
                    title="Simpan Data  Berhasil"
                    onConfirm={handleCloseSuccess}
                    btnSize="sm"
                />
            }
            {
                showProsesFailed &&
                <SweetAlert
                    danger
                    title="Simpan Data Gagal"
                    onConfirm={handleCloseFailed}
                    btnSize="sm"
                    timeout={2000}
                />
            }
        </>
    )
}

const PreviewPdf = ({ showOpenPreview, handleClosePreview, base64string }) => {
    return (
        <>
            <Modal show={showOpenPreview} onHide={handleClosePreview} size='xl'>
                <iframe
                    src={base64string}
                    title='Preview PDF'
                    width="100%"
                    height="800px"
                ></iframe>
            </Modal>
        </>
    )
}

export default ModalEvp